/**
 * Editor Action Templates
 * Maps natural language phrases to rich text editor-related actions
 */

import { ActionTemplate } from './semanticActionMapper';
import * as types from '../redux/actions/types';

// Custom action type for editor operations
export const OPEN_RICH_TEXT_EDITOR = 'OPEN_RICH_TEXT_EDITOR';

export const editorActionTemplates: ActionTemplate[] = [
	{
		intent: OPEN_RICH_TEXT_EDITOR,
		phrases: [
			'open editor',
			'open text editor',
			'open rich text editor',
			'open document editor',
			'create document',
			'write document',
			'edit document',
			'write article',
			'create article',
			'edit article',
			'write content',
			'create content',
			'edit content',
			'open writing tool',
			'start writing',
			'begin writing',
			'compose document',
			'compose article',
			'rich text',
			'text editor',
			'wysiwyg editor',
			'word processor',
		],
		reduxAction: () => ({ type: OPEN_RICH_TEXT_EDITOR }),
		category: 'ui',
		requiresConfirmation: false,
		destructive: false,
		description: 'Open rich text editor',
	},
];
















